import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { DynamicPropertyEntity } from "src/app/features/DynamicProperty/types/DynamicPropertyEntity";
import { TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const DynamicPropertiesSearchForm: FC<SearchFormProps<DynamicPropertyEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("form.system.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
            <Form.Item label={t("form.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
        </SearchForm>
    );
};
